(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tw-accordion-snippet"] && !Shopify.designMode) return;
  try {
    if (!window.__accordionBlockInit) {
    window.__accordionBlockInit = true; // ensure script runs only once
    document.querySelectorAll('.ab-js-collapsible-button').forEach((button) => {
      button.addEventListener('click', () => {
        const container = button.closest('.ab-js-collapsible-container');
        const content = button.nextElementSibling;

        // Close all other accordions
        document.querySelectorAll('.ab-js-collapsible-container').forEach((otherContainer) => {
          const otherButton = otherContainer.querySelector('.ab-js-collapsible-button');
          const otherContent = otherContainer.querySelector('.ab-js-collapsible-content');

          if (otherButton !== button) {
            otherButton.classList.remove('open');
            otherContent.classList.remove('open');
          }
        });

        // Toggle the clicked one
        content.classList.toggle('open');
        button.classList.toggle('open');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-footer-link-stack"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.js-collapsible-button').forEach((button) => {
    button.addEventListener('click', () => {
      const content = button.nextElementSibling;

      content.classList.toggle('open');
      button.classList.toggle('open');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
